import type { MockExamsStudentRow } from '../../types/mock-exams';

type ChartsData = {
  name: string;
  score: number;
}[];

function mockExamsStudentRowsToChartData(
  students: MockExamsStudentRow[],
  t: Function
): ChartsData {
  return (
    students?.map((student) => ({
      name: student?.firstName
        ? `${student.firstName} ${student.lastName}`
        : t('common.unknown'),
      score: student?.score ?? 0,
    })) ?? []
  );
}

const CORRECTNESS_VALUES = {
  YES: 'yes',
  NO: 'no',
  PARTIAL: 'partial',
} as const;
// --- helpers de evaluación ---
export type Correctness = (typeof CORRECTNESS_VALUES)[keyof typeof CORRECTNESS_VALUES];

const isSingleChoice = (s: string) => /^[A-Za-z]$/.test(s.trim());

const isMultipleChoice = (s: string) =>
  /^[A-Za-z](\s*,\s*[A-Za-z])+$/i.test(s.trim()); // ej. "A,B,D,E"

const allowsPartial = (answer?: string) =>
  !!answer && (isSingleChoice(answer) || isMultipleChoice(answer));

const normalizeToUnit = (raw: number) => (raw > 1 ? raw / 100 : raw);

const toCorrectness = (
  answer: string | undefined,
  gradePercentage: number | undefined | null
): Correctness => {
  const hasGrade = gradePercentage != null && !Number.isNaN(gradePercentage);
  const gradePercentageUnit = hasGrade ? normalizeToUnit(gradePercentage as number) : undefined;

  if (gradePercentageUnit == null) return CORRECTNESS_VALUES.NO;

  // Solo aplica "partial" si la respuesta es de tipo multiple choice
  if (!allowsPartial(answer)) {
    return gradePercentageUnit >= 1 ? CORRECTNESS_VALUES.YES : CORRECTNESS_VALUES.NO;
  }

  if (gradePercentageUnit >= 1) return CORRECTNESS_VALUES.YES;
  if (gradePercentageUnit <= 0) return CORRECTNESS_VALUES.NO;
  return CORRECTNESS_VALUES.PARTIAL;
};

export { mockExamsStudentRowsToChartData, toCorrectness, CORRECTNESS_VALUES };

